import React, { useState , createContext, useContext, useEffect } from "react";
import { LoggedInContext } from "./LoggedInContext";

const QuoteBasketContext = createContext();

function QuoteBasketProvider({children}) {

    const {loggedIn,user,backendEndpoint,handleLogin} = useContext(LoggedInContext);

    const newObjArray = [
      {
        "id": 99,
        "qty": 3
      },
      {
        "id": 100,
        "qty": 3
      },
      {
        "id": 98,
        "qty": 6
      },
      {
        "id": 31,
        "qty": 2
      },
      {
        "id": 32,
        "qty": 2
      },
      {
        "id": 36,
        "qty": 1
      }
    ];

    const [basketArray,setBasketArray] = useState([]);
    const [totalBasketQty,setTotalBasketQty] = useState(0);

    const [detailsObject,setDetailsObject] = useState({
      requestName: '',
      yourName: user.firstName+' '+user.lastName,
      yourEmail: user.email,
      onBehalf: false,
      FAOname: user.firstName+' '+user.lastName,
      FAOemail: user.email,
      addressLine1: '',
      addressLine2: '',
      townOrCity: '',
      county: '',
      postcode: '',
      telephone: '',
      specialItemRequests: '',
      notes: '',
    });

    useEffect(() => {
      if(user.firstName){
        setDetailsObject({
          requestName: '',
          yourName: user.firstName+' '+user.lastName,
          yourEmail: user.email,
          onBehalf: false,
          FAOname: user.firstName+' '+user.lastName,
          FAOemail: user.email,
          addressLine1: '',
          addressLine2: '',
          townOrCity: '',
          county: '',
          postcode: '',
          telephone: '',
          specialItemRequests: '',
          notes: '',
        });
      }
    },[user.firstName]);

    useEffect(() => {
      if(user.id !== 0){
        getBasket(user.id);
      }
    },[user.id])

    useEffect(() => {
        let newTotal = 0;
        basketArray.forEach((item) => {
            newTotal += item.qty;
        });
        setTotalBasketQty(newTotal);
    },[basketArray]);

    const getBasket = (userId) => {
        const headers = new Headers();
        headers.append('Content-Type','application/x-www-form-urlencoded');
        fetch(backendEndpoint+'/basket/'+userId,{
            method: 'GET',
            headers: headers,
            credentials: 'include',
        })
        .then((res) => res.text())
        .then((data) => {
            const recObj = JSON.parse(data);
            console.log(recObj.basketItems);
            setBasketArray(recObj.basketItems.map((item) => ({id: item.itemId, qty: item.qty})));
        })
        .catch((err) => console.log(err));
    }

    const handleUpdateBasket = (userId,basketArray) => {
      fetch(backendEndpoint+'/basket/update',{
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({userId,basketArray}),
            credentials: "include"
        })
        .then((res) => res.text())
        .then((data) => {
            const recObj = JSON.parse(data);
            console.log(recObj);
        })
        .catch((err) => console.log(err));
    }

    return (
        <QuoteBasketContext.Provider value={{basketArray,setBasketArray,detailsObject,setDetailsObject,totalBasketQty,handleUpdateBasket}}>
            {children}
        </QuoteBasketContext.Provider>
    )
}

export { QuoteBasketProvider, QuoteBasketContext };